/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { PublicPageContent, Typography, WithGap } from '@/components'
import { isString } from '@/utils'
import { useTranslation } from 'react-i18next'
import { Container } from './styles'

interface ImprintContent {
  subtitle: string
  content: string | string[]
}

export const ImprintPage = () => {
  const { t } = useTranslation()
  const content = t('imprint.content', {
    returnObjects: true,
  }) as ImprintContent[]

  return (
    <PublicPageContent>
      <Container>
        <WithGap gap={6}>
          <Typography responsive variant="h1">
            {t('imprint.title')}
          </Typography>
          {content.map(({ subtitle, content }) => (
            <>
              <Typography responsive variant="h3">
                {subtitle}
              </Typography>
              {isString(content) ? (
                <Typography variant="p1Body">{content}</Typography>
              ) : (
                content.map((item) => (
                  <Typography variant="p1Body">{item}</Typography>
                ))
              )}
            </>
          ))}
        </WithGap>
      </Container>
    </PublicPageContent>
  )
}
